import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "area_status" }
const _hoisted_3 = { class: "area_info" }
const _hoisted_4 = { class: "user_name" }
const _hoisted_5 = { class: "user_info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", null, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "icon_wrap"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "img/logo.png",
              alt: "디지털 성매매 시민참여 플랫폼 관리자"
            }, null, -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_RouterLink, { to: { name: 'newClntList' } }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createTextVNode(" [신규 내담자 확인 대기 건 수 : ", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.cntWaitForClient)) + "건", 1),
            _cache[5] || (_cache[5] = _createTextVNode(" ] ", -1))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_RouterLink, { to: { name: 'newCnslList' } }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createTextVNode(" [신규 상담일지 승인 대기 건 수 : ", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.cntWaitForCounsel)) + "건", 1),
            _cache[7] || (_cache[7] = _createTextVNode(" ] ", -1))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_RouterLink, { to: '#' }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createTextVNode(" [수정/삭제 승인( ", -1)),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'accessRequestClient' })))
            }, "내담자: " + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.cntClient)) + "건", 1),
            _cache[9] || (_cache[9] = _createTextVNode(" / ", -1)),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'accessRequestCounsel' })))
            }, "상담일지: " + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.cntCounsel)) + "건", 1),
            _cache[10] || (_cache[10] = _createTextVNode(" )] ", -1))
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, $setup.CommonUtils.checkAuth()]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, "[" + _toDisplayString($setup.user.userInfo.name) + "]", 1),
        _cache[11] || (_cache[11] = _createTextVNode(" 님 이 로그인 하셨습니다. ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, "(권한코드: " + _toDisplayString($setup.user.userInfo.auth) + ", 부서: " + _toDisplayString($setup.user.userInfo.team) + ")", 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btnLogout",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
          type: "button"
        }, "로그아웃")
      ])
    ])
  ]))
}